/* global axios */
import ApiClient from './ApiClient';

class CommercialAnalysisAPI extends ApiClient {
  constructor() {
    super('commercial-analyses', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  generate(data = {}) {
    return axios.post(this.url, data);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  status(id) {
    return axios.get(`${this.url}/${id}/status`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  exportPdfUrl(id) {
    return `${this.url}/${id}/export.pdf`;
  }
}

export default new CommercialAnalysisAPI();
